import { render, staticRenderFns } from "./DocPreviesIcon.vue?vue&type=template&id=37172540&scoped=true&"
import script from "./DocPreviesIcon.vue?vue&type=script&lang=js&"
export * from "./DocPreviesIcon.vue?vue&type=script&lang=js&"
import style0 from "./DocPreviesIcon.vue?vue&type=style&index=0&id=37172540&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37172540",
  null
  
)

export default component.exports